<template>
  <v-container class="progress-container">
    <div class="progress-counter">
    <div class="progress-description" v-html="this.getBarDescription()">
    </div>
    <v-icon ml-1 small color="primary">favorite</v-icon>
    </div>

    <div v-if="showQuorum" class="quorumContainer">
      <div class="quorum" :style="{left: `${quorumPercent}%`}">
        <div class="quorum-count">{{ proVotes }}</div>
        <div class="arrow-down"></div>
      </div>
    </div>

    <div class="bar" v-bind:class="{'small': !!this.small}">
      <div class="pro" :style="{right: this.proPercent? `${100-this.proPercent}%` : `100%`}"></div>
      <div class="contra" :style="{left: this.contraPercent? `${100-this.contraPercent}%` : `100%`}"></div>
    </div>


    <div v-if="showQuorum" class="quorumContainer">
      <div class="quorum" :style="{left: this.quorum.requiredVoteCount? `${100 * (this.quorum.requiredVoteCount / this.quorum.totalVoters)}%` : `100%`}">
        <div class="arrow-up"></div>
        <div class="quorum-count">
          <v-img src="./static/img/sports_score.svg" height="25" width="25" :contain="true"/></div>
        </div>
    </div>
  </v-container>
</template>

<script>
import ideaApi from '@/api/idea'

import * as spaceApi from '@/api/ideaSpace'

export default {
  name: 'ProgressBar',
  props: {
    proVotes: Number,
    contraVotes: Number,
    idea: Object,
    showQuorum: Boolean,
    small: Boolean
  },
  data: function () {
    return {
      spaceSlug: 'school',
      quorum: {
        classQuorum: 30,
        schoolQuorum: 30,
        totalVoters: 0,
        requiredVoteCount: 0
      }
    }
  },
  beforeMount: function () {
    this.getSpaceInfo()
  },
  computed: {
    proPercent: function () {
      if (this.quorum.totalVoters === 0) {
        return 0
      }
      return 100 * Math.min(this.proVotes / this.quorum.totalVoters, 1)
    },
    contraPercent: function () {
      if (this.quorum.totalVoters === 0) {
        return 0
      }
      return 100 * Math.min(this.contraVotes / this.quorum.totalVoters, 1)
    },
    quorumPercent: function () {
      // return 100 * Math.min(this.quorum.requiredVoteCount / this.quorum.totalVoters, 1)
      if (!this.contraPercent) {
        return this.proPercent
      }
      const quorumPercent = this.proPercent - this.contraPercent

      if (quorumPercent < 0) {
        return 0
      }
      return quorumPercent
    }
  },
  methods: {
    getBarDescription: function () {
      if (this.showQuorum) {
        return this.$vuetify.t('$vuetify.Idea.supporterCount', this.proVotes, this.quorum.totalVoters)
      }
      return this.$vuetify.t('$vuetify.Idea.votesCount', this.proVotes, this.contraVotes)
    },
    getSpaceInfo: function () {
      this.spaceSlug = this.$route.params['spaceSlug']
      let spaceId = this.$route.params['spaceId']
      if (this.spaceSlug !== 'school') {
        spaceApi.getSpace(this.$store.getters.selected_school, this.$route.params['spaceSlug'])
          .then((res) => {
            spaceId = res.data[0].id
            this.getQuorumInfo(spaceId)
          })
      } else {
        this.getQuorumInfo(spaceId)
      }
    },
    getQuorumInfo: function (ideaSpaceId) {
      ideaApi.getQuorumInfo(
        this.$store.getters.selected_school,
        ideaSpaceId
      ).then(resp => {
        this.quorum = resp.data
      })
    }
  }
}
</script>

<style lang="scss">
.progress-container{
     background-color: #eee;
     border-radius: var(--var-border-radius);
     margin-bottom: 1rem;
     padding: 1rem;

     .progress-counter {
      padding-bottom: 1rem;
      display: flex;

        .progress-description{
          padding: 0rem 0.3rem 0rem 0rem;

          .supportNum {
            color: var(--v-primary-base);
          }

          .againstNum {
            color: var(--v-secondary-base);
          }

          .neededNum {
            color: #777;
          }
        }
}
.bar{
  background: var(--v-warning-lighten5);
  border-radius: var(--var-border-radius);
  position: relative;
  height: 2rem;
  overflow: hidden;

  &.small{
    height: 1rem;
  }

  .pro{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: var(--v-primary-base);
    transition: right 0.5s;
  }
  .contra{
    position: absolute;
    border-radius: var(--var-border-radius);
    top: 0;
    right: 0;
    bottom: 0;
    background-color: var(--v-secondary-base);
    transition: left 0.5s;
  }
}

.quorumContainer{
  width: calc(100% - 2px);
  height: 38px;
  display: inline-block;
  position: relative;
  margin: 0 1px -10px 1px;

  .quorum{
    position: absolute;
    bottom: 0;
    width: 32px;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    font-size: 16px;

    .arrow-up {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 6px 5px;
      border-color: transparent transparent rgba(0, 0, 0, 0.48) transparent;
    }
    .arrow-down {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 5px 0 5px;
      border-color: rgba(0, 0, 0, 0.48) transparent transparent transparent;
    }
    i {
      font-size: 24px;
      margin-top: -4px;
    }
    .quorum-count{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.48);
      line-height: 26px;
      border-radius: var(--var-border-radius);
      color: white;
    }
  }
}

}
</style>
